export type Details = {
  badge: string;
  title: string;
  accentWord: string;
  subtitle: string;
};

export const NewsPageDetails: Details = {
  badge: 'Informação',
  title: 'Notícias.',
  accentWord: 'Notícias.',
  subtitle: 'Mantenha-se informado sobre tudo o que acontece na nossa freguesia.',
};
